import React, { FC, ElementType, useCallback } from "react";
import { useSelector } from "react-redux";
import { ActionsGroup, RaisedButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { Error } from "components/Icons/Error";
import { connectionStatus, hasConnectionProblem } from "../../../ducks/sp/selectors";
import { PublicConnectionStatus, SpState } from "../../../ducks/sp/sp";
import { ConnectionLostMessage } from "./ConnectionLostMessage";
import { InvalidWorkspaceMessage } from "./InvalidWorkspaceMessage";
import { Dialog, DialogActions, DialogContent } from "./styled";
import { UnauthorizedMessage } from "./UnauthorizedMessage";

const noop = () => null;

const connectionProblemMessages: Partial<Record<SpState | "default", ElementType>> = {
  [PublicConnectionStatus.InvalidWorkspace]: InvalidWorkspaceMessage,
  [PublicConnectionStatus.Unauthorized]: UnauthorizedMessage,

  /** for all other statuses */
  default: ConnectionLostMessage,
};

export const ConnectionProblem: FC = () => {
  const { t } = useTranslation("common");
  const status = useSelector(connectionStatus);
  const connectionProblem = useSelector(hasConnectionProblem);
  const refreshPage = useCallback(() => window.location.reload(), []);
  const Message = connectionProblemMessages[status] || connectionProblemMessages.default;

  if (process.env.NODE_ENV === "development") {
    return null;
  }

  return (
    <Dialog modal zIndex={999} isOpen={connectionProblem} onCloseRequest={noop}>
      <DialogContent>
        <Error />
        {connectionProblem && <Message />}
      </DialogContent>

      <DialogActions>
        <ActionsGroup>
          <RaisedButton primary onClick={refreshPage}>
            {t("actions.refresh")}
          </RaisedButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
